import { combineReducers } from "redux";
import results from "./results"


export default combineReducers({
    results
})